export default "__VITE_ASSET__Bo9mPH1j__"